module.exports = __webpack_public_path__ + "img/2f_r_horse.d4bb3cce.png";